import GraphicIcon from './component'

export default GraphicIcon
